export default __webpack_public_path__ + "assets/e21ba390208be85c5e61653a247003dd.woff";